import { MARKETPLACE_FEATURE } from '@/config/marketplaceCapabilities.js';

export default [
  {
    title: 'Listings',
    channel: 'amazon-seller',
    icon: { icon: 'ic:outline-inventory-2' },
    envOnly: 'development',
    feature: MARKETPLACE_FEATURE.LISTINGS,
    children: [
      {
        title: 'Listings (Current State)',
        action: 'read',
        subject: 'User',
        to: 'business-reports-listings-items',
        icon: { icon: 'ic:outline-list-alt' },
        envOnly: 'development',
      },
      {
        title: 'Customer Review Topics',
        action: 'read',
        subject: 'User',
        to: 'business-reports-review-topics',
        icon: { icon: 'ic:outline-reviews' },
        envOnly: 'development',
      },
      {
        title: 'Competitive Pricing & Buy Box',
        action: 'read',
        subject: 'User',
        to: 'business-reports-pricing-competitive',
        icon: { icon: 'ic:outline-sell' },
        envOnly: 'development',
      },
    ],
  },
];
